<template>
  <component :is="layoutVariant" class="layout-base">
    <slot />
  </component>
</template>

<script>
import store from '@/services/store';

import LayoutBasePublic from './LayoutBasePublic.vue';
import LayoutBasePrivate from './LayoutBasePrivate.vue';

export default {
  name: 'LayoutBase',

  computed: {
    isLoggedIn: () => store.getters['auth/isLoggedIn'],
    layoutVariant: (vm) => (vm.isLoggedIn ? LayoutBasePrivate : LayoutBasePublic),
  },
};
</script>

<style lang="scss" scoped>
.layout-base {
  display: flex;
  flex: 1 0 auto;
}
</style>
